module.exports = ".center {\n  margin: auto;\n  width: 25%;\n  padding: 10px;\n}\n\n.space-bottom {\n  padding-bottom: 15px;\n}\n"